import {Component, type ErrorInfo, type ReactNode} from "react";

import {captureRenderError, shouldCaptureBoundaryError} from "@/src/modules/core/lib/glitchtip";

type GlitchTipErrorBoundaryProps = {
  children: ReactNode;
  fallback: (props: {error: unknown; resetError: () => void}) => ReactNode;
};

type GlitchTipErrorBoundaryState = {
  error: unknown | null;
};

export class GlitchTipErrorBoundary extends Component<
  GlitchTipErrorBoundaryProps,
  GlitchTipErrorBoundaryState
> {
  state: GlitchTipErrorBoundaryState = {error: null};

  static getDerivedStateFromError(error: unknown): GlitchTipErrorBoundaryState {
    return {error};
  }

  componentDidCatch(error: unknown, _errorInfo: ErrorInfo): void {
    if (!shouldCaptureBoundaryError(error)) return;
    captureRenderError(error);
  }

  resetError = (): void => {
    this.setState({error: null});
  };

  render(): ReactNode {
    const {error} = this.state;
    if (error) {
      return this.props.fallback({error, resetError: this.resetError});
    }
    return this.props.children;
  }
}
